import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ArrowbackIcon from "../../assets/icons/arrow_back.svg";
import EmployeeIcon from "../../assets/icons/manager_accounts.svg";
import ManagerIcon from "../../assets/icons/supervisor_account.svg";
import BiographicalIcon from "../../assets/icons/bio.svg";
import ContactIcon from "../../assets/icons/phone.svg";
import AddressIcon from "../../assets/icons/address.svg";
import WorkIcon from "../../assets/icons/experience.svg";
import EducationIcon from "../../assets/icons/school.svg";
import JobIcon from "../../assets/icons/job.svg";
import SubmitIcon from "../../assets/icons/inventory.svg";
import "./ManageAccess.css";
import { categories } from "../../constants/manager";
import { getEssMssFields, updateEssMss } from "../../store/ManagerSlice/thunk";
import { useDispatch, useSelector } from "react-redux";

const ManageAccess = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [navSelected, setNavSelected] = useState("employee");

  const essMssFields = useSelector(state => state.manager.essMssFields || []);
  const [checkedItems, setCheckedItems] = useState({});
  const [initialCheckedItems, setInitialCheckedItems] = useState({});
  const [isInitialized, setIsInitialized] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);


  useEffect(() => {
    dispatch(getEssMssFields({
      user_type: navSelected === "employee" ? "USER" : "MANAGER"
    }));
  }, [dispatch, navSelected]);




  useEffect(() => {

    if (essMssFields && essMssFields.length > 0 && !isInitialized) {

      let allCategories = {}
      if (navSelected == "employee") {
        allCategories = {
          ...categories.bio,
          ...categories.contact,
          ...categories.address,
          // ...categories.education,
          // ...categories.work,
          // ...categories.job,
        };
      }
      else allCategories = categories.manager

      const initialCheckedState = Object.keys(allCategories).reduce((acc, key) => {
        acc[key] = essMssFields.includes(key);
        return acc;
      }, {});

      setCheckedItems(initialCheckedState);
      setInitialCheckedItems(initialCheckedState);
      setIsInitialized(true);
    }
  }, [essMssFields, isInitialized]);

  useEffect(() => {
    setIsInitialized(false);
    setHasChanges(false);
  }, [navSelected]);


  useEffect(() => {
    if (isInitialized) {
      const changesDetected = Object.keys(checkedItems).some(
        key => checkedItems[key] !== initialCheckedItems[key]
      );
      setHasChanges(changesDetected);
    }
  }, [checkedItems, initialCheckedItems, isInitialized]);


  const handleSubmit = () => {
    if (!hasChanges) return;

    const checkedKeys = Object.keys(checkedItems).filter((key) => checkedItems[key]);

    const payload = {
      user_type: navSelected === "employee" ? "ess" : "mss",
      data: checkedKeys,
    };

    dispatch(updateEssMss(payload));
  };

  const handleCheckboxChange = (key) => {
    setCheckedItems((prev) => ({
      ...prev,
      [key]: !prev[key]
    }));
  };


  const showSection = (categoryName, icon, items) => {
    return (
      <div className="flex flex-col">
        <div className="flex items-center mn-cat-head-wrap">
          <img className="mn-cat-ico" alt="mn-icons" src={icon} />
          <div className="mn-cat-head">{categoryName}</div>
        </div>
        <div className="flex mn-cat-content">
          {Object.keys(items).map((key) => (
            <div key={key} className="flex mn-cat-item" onClick={() => handleCheckboxChange(key)}>
              <input
                className="mn-input-check w-full rounded border border-gray-300 px-3 py-2"
                type="checkbox"
                checked={checkedItems[key] || false}
                readOnly
              />
              <div className="mn-input-text">{items[key]}</div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="mn-home">
      <div className="flex items-center">
        <img
          className="mn-back-ico"
          src={ArrowbackIcon}
          alt="arrow-back"
          onClick={() => navigate("../../people")}
        />
        <div className="mn-head">manage access</div>
        <div className="flex items-center ml-auto">
          <div className="flex w-full">
            <div
              className={`btn p-btn ${hasChanges ? 'p-btn-og' : 'p-btn-disabled'}`}
              onClick={handleSubmit}
              disabled={!hasChanges}
            >
              <img className="p-btn-icon" alt="" src={SubmitIcon} />
              <div className="p-btn-text">Submit</div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex form-nav">
        <div
          className={`flex items-center form-nav-item ${navSelected === "employee" && "active"}`}
          onClick={() => setNavSelected("employee")}
        >
          <img src={EmployeeIcon} alt="nav-icon" className="nav-icon" />
          <a href="#employee" className="nav-text">
            Employee Access
          </a>
        </div>
        <div
          className={`flex items-center form-nav-item ${navSelected === "manager" && "active"}`}
          onClick={() => setNavSelected("manager")}
        >
          <img src={ManagerIcon} alt="nav-icon" className="nav-icon" />
          <a href="#manager" className="nav-text">
            Manager Access
          </a>
        </div>
      </div>
      <div className="mn-subhead">
        Select the fields that are editable by the {navSelected}.
      </div>

      <div className="flex flex-col">
        {navSelected === "employee" && (
          <>
            {showSection("biographical", BiographicalIcon, categories.bio)}
            {showSection("contact details", ContactIcon, categories.contact)}
            {showSection("address details", AddressIcon, categories.address)}
            {/* {showSection("education details", EducationIcon, categories.education)} */}
            {/* {showSection("work experience", WorkIcon, categories.work)} */}
            {/* {showSection("job details", JobIcon, categories.job)} */}
          </>
        )}
        {navSelected === "manager" &&
          showSection("miscellaneous", ManagerIcon, categories.manager)}
      </div>
    </div>
  );
};

export default ManageAccess;